var map = {
	"./กุน.jpg": 2037,
	"./ขาล.jpg": 2038,
	"./จอ.jpg": 2039,
	"./ฉลู.jpg": 2040,
	"./ชวด.jpg": 2041,
	"./มะเมีย.jpg": 2042,
	"./มะเส็ง.jpg": 2043,
	"./มะแม.jpg": 2044,
	"./มะโรง.jpg": 2045,
	"./ระกา.jpg": 2046,
	"./วอก.jpg": 2047,
	"./เถาะ.jpg": 2048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 697;